import { Close as IconClose } from "@mui/icons-material";
import { Box, IconButton, Tab, Tabs, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, Outlet, useLocation, useParams } from "react-router";

import { MapPanel, MapPanelHeader, MapPanelScrollableArea } from "~/modules/map/components/MapPanel";
import useMapEditorLayerGetById from "~/modules/mapEditor/api/useMapEditorLayerGetById";

import useCreateProjectUrl from "../../../hooks/useCreateProjectUrl";
import { useWithSearch } from "../../../hooks/useWithSearch";

export function ProjectMapEditorLayerScreen() {
    const { layerId } = useParams();
    if (!layerId) throw new Error("Missing layerId");
    const createProjectUrl = useCreateProjectUrl();
    const withSearch = useWithSearch();
    const { t } = useTranslation("mapEditor");
    const { data: layerData } = useMapEditorLayerGetById(layerId);

    const location = useLocation();
    // Settings tab is active only when explicitly on /settings
    // Features tab is active for everything else (including child routes)
    const activeTab = location.pathname.includes("/settings") ? "settings" : "features";

    return (
        <MapPanel>
            <MapPanelHeader sx={{ justifyContent: "space-between" }}>
                <Typography variant="h5">{layerData?.name}</Typography>
                <Box>
                    <IconButton component={Link} color="inherit" to={withSearch(createProjectUrl("map-editor"))}>
                        <IconClose />
                    </IconButton>
                </Box>
            </MapPanelHeader>
            <Tabs variant="fullWidth" value={activeTab}>
                <Tab
                    value="features"
                    component={Link}
                    to={withSearch(createProjectUrl(`map-editor/${layerId}`))}
                    label={t("mapEditorFeatureList.labelFeatureList")}
                />
                <Tab
                    value="settings"
                    component={Link}
                    to={withSearch(createProjectUrl(`map-editor/${layerId}/settings`))}
                    label={t("mapEditorFeatureList.labelSettings")}
                />
            </Tabs>
            <MapPanelScrollableArea>
                <Outlet />
            </MapPanelScrollableArea>
        </MapPanel>
    );
}
